import { useLayoutEffect } from 'react'

/**
 * Dynamically loads SCSS styles for a specific publisher
 * @param publisherId - Publisher ID or null
 */
export const usePublisherStyles = (publisherId = null) => {
    useLayoutEffect(() => {
        const loadStylesheet = async id => {
            const styleToLoad = id ? `${id}.scss` : 'default.scss'

            try {
                await import(`../modules/styles/${styleToLoad}`)
                console.log(`${id ? 'Stylesheet' : 'Default stylesheet'} loaded for pub:`, id ?? 'default')
            } catch {
                try {
                    await import(`../modules/styles/default.scss`)
                    console.log('Fallback default stylesheet loaded')
                } catch {
                    console.log('No stylesheet loaded')
                }
            }
        }

        loadStylesheet(publisherId)
    }, [publisherId])
}
